/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';
import { Field } from 'redux-form';
import { FormCheckboxField } from '../../../../../../../semantic-ui/components/form-checkbox-field';
import { TABLE_SETTINGS_COLUMNS_NAMES } from '../../../../constants';
import { TableComponent } from '../../../../../../../components/table-component';
import { CustomLoader } from '../../../../../../../components/custom-loader';

const CompanySettingView = ({ companySettingInfo, isCompanySettingInfoLoading }) => {
	if (isCompanySettingInfoLoading || !companySettingInfo?.data) {
		return <CustomLoader />;
	}

	const { transports, my_transports } = companySettingInfo.data;

	const tableTransportsRows = [
		{
			id: 'accredited-all',
			label: 'Считать весь транспорт аккредитованным по умолчанию',
			value: (
				<div className="company-setting-view__checkbox">
					<Field
						name="transports"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						disabled
						checked={Boolean(transports)}
					/>
				</div>
			),
		},
	];

	const tableMyTransportsRows = [
		{
			id: 'accredited-my-all',
			label: 'Считать мой автопарк аккредитованным по умолчанию',
			value: (
				<div className="company-setting-view__checkbox">
					<Field
						name="my_transports"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						disabled
						checked={Boolean(my_transports)}
					/>
				</div>
			),
		},
	];

	const { stages, documents } = companySettingInfo.data;

	const isDoneEnabled = stages.some(stage => stage.key === 'done' && stage.value === true);

	const tableStagesRows = [
		...stages.map(stage => ({
			id: stage.key,
			label: stage.name,
			value: (
				<div className="company-setting-view__checkbox">
					<Field
						name={`stages.${stage.key}`}
						component={FormCheckboxField}
						toggle
						type="checkbox"
						disabled
						checked={Boolean(stage.value)}
					/>
				</div>
			),
		})),
	];

	const tableDocumentsRows = [
		...(isDoneEnabled && documents.length > 0
			? [
					...documents.map((doc, index) => ({
						id: doc.key,
						label: `Документ №${index + 1}`,
						value: doc.name,
					})),
			  ]
			: []),
	];

	return (
		<div>
			<div className="company-setting-view__header_text_section">Транспорт моих ТЭО</div>
			<TableComponent
				columns={TABLE_SETTINGS_COLUMNS_NAMES}
				rows={tableTransportsRows}
				isTableDataLoading={isCompanySettingInfoLoading}
				isWithoutHeader
				isChildren
				isInfo
				isWithoutTableHeader
			/>
			<div className="company-setting-view__header_text_section">Мой автопарк</div>
			<TableComponent
				columns={TABLE_SETTINGS_COLUMNS_NAMES}
				rows={tableMyTransportsRows}
				isTableDataLoading={isCompanySettingInfoLoading}
				isWithoutHeader
				isChildren
				isInfo
				isWithoutTableHeader
			/>
			<div className="company-setting-view__header_text_section_small">Жизненный цикл заявки</div>
			<TableComponent
				columns={TABLE_SETTINGS_COLUMNS_NAMES}
				rows={tableStagesRows}
				isTableDataLoading={isCompanySettingInfoLoading}
				isWithoutHeader
				isChildren
				isInfo
				isWithoutTableHeader
			/>
			{isDoneEnabled && (
				<>
					<div className="company-setting-view__header_text_section_small">
						Требовать документы по доставке груза
					</div>
					<TableComponent
						columns={TABLE_SETTINGS_COLUMNS_NAMES}
						rows={tableDocumentsRows}
						isTableDataLoading={isCompanySettingInfoLoading}
						isWithoutHeader
						isChildren
						isInfo
						isWithoutTableHeader
					/>
				</>
			)}
		</div>
	);
};

CompanySettingView.propTypes = {
	companySettingInfo: PropTypes.object,
	isCompanySettingInfoLoading: PropTypes.bool.isRequired,
	formValues: PropTypes.object,
};

export default CompanySettingView;
